import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import { getYear } from '../../../../helper'
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';

const CedulaTransactionsSmartCity = ({
  getList,
  list,
  isLoading,
  pager
}) => {
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState({
    permit_type: 'Community Tax Certificate CTC / CEDULA',
    printed_by: '',
  });
  const [cedulatListing, setCedulatListing] = useState([])

  const syncFilters = params => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleChangePage = page => {
    getList({ ...formData, page });
    syncFilters({ ...formData, page });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    syncFilters({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getList({
      permit_type: 'Community Tax Certificate CTC / CEDULA',
      ...queryString.parse(window.location.search),
    }, res => setCedulatListing(res.data))
  }, []);


  const onSearch = e => {
    e.preventDefault();
    const args = {
      ...formData,
      permit_type: 'Community Tax Certificate CTC / CEDULA',
    }
    getList(args)
  };

  const onClear = e => {
    e.preventDefault();
    setFormData({
      printed_by_full_name: '',
      printed_by: '',
      q: '',
    });
    syncFilters({
      printed_by_full_name: '',
      printed_by: '',
      q: '',
    });
    getList({ permit_type: 'Community Tax Certificate CTC / CEDULA' });
    history.replace({ pathname: window.location.pathname });
  };

  const getReports = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/administrators/reports/transaction_histories/generate_csv`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...formData,
      permit_type: 'Community Tax Certificate CTC / CEDULA',
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    syncFilters({ ...formData, [key]: e ? e.value : '' });
  };

  const filterAccount = () => {
    const accountLists = cedulatListing || []

    const optionList = accountLists?.map(item => {
      const value = _.get(item, "attributes.printed_by") === null ? "---" : String(_.get(item, "attributes.printed_by"))
      const label = _.get(item, "attributes.printed_by") === null ? "---" : _.get(item, "attributes.printed_by_full_name")
      return { value, label }
    })
    
    return _.uniqBy([{ value: "", label: "ALL"}, ...optionList], 'value')
  }

  return (
    <div className="">
      <form onSubmit={onSearch}>
        <div className="row mt-2">
          {/* transaction_type */}
          <div className="col-2 pr-0">
            <div className="form-group">
              <label className="label-reports">Transaction Types</label>
              <Select
                name="transaction_type"
                placeholder="Select Module Type"
                onChange={handleChangeSelect('transaction_type')}
                options={c.CDL_TRANSACTIONS}
                value={
                  query.transaction_type
                    ? {
                      value: query.transaction_type,
                      label: query.transaction_type,
                    }
                    : { value: '', label: 'ALL' }
                }
              />
            </div>
          </div>
          {/* transaction_status */}
          <div className="col-2 pr-0 " style={{ zIndex: 1 }}>
            <div className="form-group">
              <label className="label-reports">Status Options</label>
              <Select
                value={
                  query.transaction_status
                    ? {
                      value: query.transaction_status,
                      label: query.transaction_status,
                    }
                    : { value: '', label: 'ALL' }
                }
                name="transaction_status"
                placeholder="Select Status Option"
                onChange={handleChangeSelect('transaction_status')}
                options={c.STATUS_OPTIONS}
              />
            </div>
          </div>
          {/* Account */}
          <div className="form-input-group col-2">
            <label className="label-reports">Account:</label>
            <Select
              name="printed_by"
              placeholder="Select Account"
              onChange={handleChangeSelect('printed_by')}
              options={filterAccount()}
              value={filterAccount()?.find((item) => _.get(formData, "printed_by") === _.get(item, "value")) || ""}
            />
          </div>
          <div className="col-2 pr-0">
            <div className="form-group">
              <label className="label-reports">Keyword</label>
              <input
                className="form-control"
                name="q"
                onChange={onChange}
                value={query.q || ''}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-6 pr-0">
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-link button-filter mt-1"
              >
                <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
              </button>
              &nbsp;
              <button
                onClick={onClear}
                type="button"
                className="btn btn-link button-clear mt-1"
              >
                <i className="fas fa-times" /> &nbsp;&nbsp;Clear
              </button>
            </div>
          </div>
        </div>
      </form>
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="ml-auto">
          <div className="">
            <a
              href={getReports()}
              className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
              style={{ color: 'white' }}
            >
              <i className="fas fa-cloud-download-alt mr-2" />
              Download
            </a>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div
          className="loading d-flex text-center justify-content-center align-items-center"
          style={{ height: '500px' }}
        >
          <div className="spinner text-center ">
            <span className="fas fa-5x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-sm table-bordered table-hover">
            <thead className="table-header">
              <tr>
                <th className="align-middle text-uppercas text-center">Account</th>
                <th className="align-middle text-uppercase text-center">YEAR</th>
                <th className="align-middle text-uppercase text-center">Place of Issue</th>
                <th className="align-middle text-uppercase text-center">Date Issue</th>
                <th className="align-middle text-uppercase text-center">Serial Number</th>
                <th className="align-middle text-uppercase text-center">NAME</th>
                <th className="align-middle text-uppercase text-center">Tax Identification Number</th>
                <th className="align-middle text-uppercase text-center">Address</th>
                <th className="align-middle text-uppercase text-center">Kind of Organization</th>
                <th className="align-middle text-uppercase text-center">Place of Incorporation</th>
                <th className="align-middle text-uppercase text-center">Date of Reg/Incorporation</th>
                <th className="align-middle text-uppercase text-center">Kind/Nature of Business</th>
                <th className="align-middle text-uppercase text-center">A. Basic Tax Community</th>
                <th className="align-middle text-uppercase text-center">B. Assessed value of Real Property</th>
                <th className="align-middle text-uppercase text-center">B. Gross Receipt</th>
                <th className="align-middle text-uppercase text-center">B. Gross Receipt (Business)</th>
                <th className="align-middle text-uppercase text-center">Total</th>
                <th className="align-middle text-uppercase text-center">Total Amount Paid</th>
              </tr>
            </thead>
            <tbody className="table-details">
              {list.map((item) => {
                const modules = _.get(item, 'attributes.module')
                const formattedAddress = `
                  ${_.get(modules, "barangay_name", "--")}
                  ${_.get(modules, "street", "--")}
                `
                
                return (
                  <tr key={item.id}>
                    {/* account */}
                    <td className="align-middle text-uppercase text-center">
                      {/* {_.get(item, 'attributes.name') || '---'} */}
                      {_.get(item, 'attributes.printed_by') ? _.get(item, 'attributes.printed_by_full_name') : '---'}
                    </td>
                    {/* Year */}
                    <td className="align-middle text-uppercase text-center">
                      {getYear(_.get(item, 'attributes.transaction_date')) || '---'}
                    </td>
                    {/* Place of issue */}
                    <td className="align-middle text-uppercase text-center">
                      {/* {_.get(item, 'attributes.place_of_issue') || '---'} */}
                      CTO - BORONGAN
                    </td>
                    {/* date issued */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.transaction_date') || '---'}
                    </td>
                    {/* serial no. */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(modules, 'serial_number') || '---'}
                    </td>
                    {/* name */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.name') || '---'}
                    </td>
                    {/* tin */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(modules, 'tin') || '---'}
                    </td>
                    {/* address */}
                    <td className="align-middle text-uppercase text-center">
                      {formattedAddress}
                    </td>
                    {/* kind of organization */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.organization') || '---'}
                    </td>
                    {/* place of incorporation */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(modules, 'place_of_registration') || '---'}
                    </td>
                    {/* Date of Reg/Incorporation */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(modules, 'date_of_registration') || '---'}
                    </td>
                    {/* Kind/Nature of Business */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.nature_of_business') || '---'}
                    </td>
                    {/* A. Basic Community Tax */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(modules, 'total_assessed_value_of_real_property_cedula') || '---'}
                    </td>
                    {/* B.Assessed value of Real Property */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.additional_residence_tax_cedula_1_human') || '---'}
                    </td>
                    {/* B. Gross Receipt Business */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.additional_residence_tax_cedula_2_human') || '---'}
                    </td>
                    {/* B. Gross Receipt Salary  */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.additional_residence_tax_cedula_3_human') || '---'}
                    </td>
                    {/* total */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.total') || '---'}
                    </td>
                    {/* total paid amount */}
                    <td className="align-middle text-uppercase text-center">
                      {_.get(item, 'attributes.amount') || '---'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

CedulaTransactionsSmartCity.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CedulaTransactionsSmartCity);
